// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {
 
		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});


	// slick default setting
	let defaulsettings = {loop: true,speed: 700,effect: 'fade',fadeEffect: {crossFade: true},navigation: { nextEl: '.swiper-prev', prevEl: '.swiper-next' },autoplay: {delay: 5000,disableOnInteraction: false}};
	//start slider default
	document.querySelectorAll('.swiper-js').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper): defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"")
		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);

		// start count custom
		customcount(`[data-swiper-${i}] ${swiperConfig.customcount}`);
		swiper.on('slideChange', () => {
			// //refresh count cutom
			document.querySelectorAll(`[data-swiper-${i}] .counter`).forEach((element) =>{
				element.innerHTML = `0${swiper.realIndex +1}`   ;
                progressBar();
			});
		});

        //add custom count 
        function customcount(element){
            let countcontainerall= document.querySelectorAll(element);
            countcontainerall.forEach((element) =>{
                let addstring =`<span class="counter">0${swiper.realIndex + 1} </span>
                                                <span class="count-line"></span>
                                                <span class="total-count">0${document.querySelectorAll( ".swiper-wrapper > article" ).length}</span>`;
                element.innerHTML = addstring;
            });
        }
	});


    function progressBar(){
		$('.slider-progress').find('span').removeAttr('style');
		$('.slider-progress').find('span').removeClass('active');
		setTimeout(function(){
			 $('.slider-progress').find('span').css('transition-duration', (4000/1000)+'s').addClass('active');
		}, 100);
	}

    progressBar();

 
    /* Add span to all btns */
    function addSpanButtons() {
        document.querySelectorAll('.btn').forEach((ele) => {
            if (!ele.querySelector('span')) {
                var actualtext = ele.textContent;
                ele.innerHTML = `<span>${actualtext}</span>`;
            }
             ele.addEventListener('click', function (evento) {
                let hasHref = ele.hasAttribute('href');
                if (hasHref) {
                    let hrefTarget = ele.getAttribute('href');
                    if (hrefTarget.startsWith("#")) {
                        let elemTarget = document.querySelector(hrefTarget);
                        if (elemTarget && !ele.hasAttribute("data-fancybox")) {
                            evento.preventDefault();
                            elemTarget.classList.remove('hide');
                            $('html, body').animate({ scrollTop: $(elemTarget).offset().top - 100 }, 1000);
                        }
                    }
                }
            });
        });
    }

	addSpanButtons();





	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

 
	// ------ Script Quad Accordion --------
	// let accordionItems = document.querySelectorAll('.accordion__item');
	// let i;
	// for (i = 0; i < accordionItems.length; i++) {
	// 	let disItem = accordionItems[i];
	// 	let disBtn = disItem.querySelector('.accordion__btn');
	// 	disBtn.addEventListener('click', function () {
	// 		if(disItem.classList.contains('open')){
	// 			disItem.classList.remove('open');
	// 			this.querySelector('.accordion__icon span').classList.remove('js-hover-button');
	// 			this.querySelector('.accordion__icon span').textContent = "READ MORE" 
	// 		}
	// 		else{
	// 			disItem.classList.add('open');
	// 			let button = disBtn.querySelector('.btn span');
	// 			button.textContent = "READ LESS" 
	// 			button.classList.add('js-hover-button');
	// 		}
	// 	});
	// }

	//-------End Script Accordeon ---------


}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}